module.exports = __webpack_public_path__ + "media/src/images/logo-iversity-without-padding-18c8180ef5a17a74c17575b9eae8d206.png";